import { useMemo } from 'react';

import styles from './alert-badge.module.scss';
import { AlertBadgeType, mapper } from './color-mapper';

type Props = {
    type: AlertBadgeType;
    text: string;
};

const AlertBadge = ({ type, text }: Props) => {
    const { icon, bgColor, primaryColor, borerColor } = useMemo(() => {
        return mapper[type];
    }, [type]);

    return (
        <div
            className={styles.badge}
            style={{ backgroundColor: bgColor, borderColor: borerColor }}
        >
            {icon}
            <span style={{ color: primaryColor }}>{text}</span>
        </div>
    );
};

export { AlertBadge };
